import { z } from 'zod';

export const PromptMetaSchema = z
  .object({
    id: z.string(),
    type: z.string(),
    name: z.string(),
    fetchedAt: z.string(),
    version: z.string(),
    latestChange: z.string().nullish(),
    latestChangeAuthor: z.string().nullish(),
    labels: z.array(z.string()).nullish(),
    tags: z.array(z.string()).nullish(),
  })
  .strip();

export const AgentMetadataSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    prompt: PromptMetaSchema.optional(),
    extra: z.record(z.string(), z.unknown()).optional(),
  })
  .strip();

export type PromptMeta = z.infer<typeof PromptMetaSchema>;

export type AgentMetadata = z.infer<typeof AgentMetadataSchema>;
